import Vue from 'vue'
import GmapCluster from 'vue2-google-maps/src/components/cluster'

Vue.component('GmapCluster', GmapCluster)
